export default __webpack_public_path__ + "ui/assets/img/arrow-down-white-20.svg";